import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { MatTable } from "@angular/material/table";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TaskAssignmentDialogComponent } from "../../../modals/task-assignment-dialog/task-assignment-dialog.component";
import {
    TaskAssignmentExposureContribution,
    TaskTimeRange,
} from "src/app/models/taskAssignment.model";
import { MultipleTaskAssignmentDialog } from "../../../modals/multiple-task-assignment-dialog/multiple-task-assignment-dialog";
import { DeleteDialog } from "src/app/shared/delete-dialog/delete-dialog.component";
import { TaskAssignmentService } from "src/app/services/taskAssignment.service";
import { ErrorConstants } from "src/app/shared/constants/error.constants";

import { trackByIndex } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-exposure-contributions",
    templateUrl: "./exposure-contributions.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./exposure-contributions.component.scss"],
})
export class ExposureContributionsComponent implements OnInit {
    @Input() taskAssignmentColumnsToDisplay;
    @Input() taskAssignmentColumnsToDisplayStr;
    @Input() taskColor;
    @Input() taskSelectColor;
    @Input() taskAssignmentDataSource;
    @Input() loadingAssessments;
    @Input() taskAssignmentColumnsToDisplayWithExpand;
    @Input() taskAssignmentExposureExpandedElement;
    @Input() sensorAssignmentData;
    @Input() selectedTaskName;
    @Input() taskRangeVisibility;
    @Input() showNewTask = true;

    @Output() sortExposureContributionsEmit = new EventEmitter<any>();
    @Output() showTaskRangeEmit = new EventEmitter<any>();
    @Output() clearTaskRangesEmit = new EventEmitter<any>();
    @Output() loadTaskAssignmentEmit = new EventEmitter<any>();

    showPPE = {};
    errorMessage = "";
    @ViewChild("exposureContributionsTable") table: MatTable<any>;

    constructor(
        private dialog: MatDialog,
        private taskAssignmentService: TaskAssignmentService,
    ) {
        this.errorMessage = ErrorConstants.errorMessage;
    }

    ngOnInit(): void {}

    showTaskRange(visibility = false, taskName = null) {
        this.showTaskRangeEmit.emit({ visibility, taskName });
    }

    clearTaskRanges(event) {
        this.clearTaskRangesEmit.emit(true);
    }

    sortExposureContributions(sort: any) {
        this.sortExposureContributionsEmit.emit(sort);
        setTimeout(() => {
            this.table.renderRows();
        }, 200);
    }

    showHidePPE(i, show = false) {
        // tslint:disable-next-line:forin
        for (const showPPEKey in this.showPPE) {
            this.showPPE[showPPEKey] = false;
        }
        if (!show) {
            setTimeout(() => {
                this.showPPE[i] = show;
            }, 2000);
        } else {
            this.showPPE[i] = show;
        }
    }

    openTaskDialog(taskAssignment?: TaskAssignmentExposureContribution) {
        let taskAssignmentId = '';
        const firstTaskAssignment = taskAssignment?.taskAssignments?.[0];
        if (firstTaskAssignment) {
            taskAssignmentId = firstTaskAssignment.id;
        }

        let taskTimeRanges: TaskTimeRange[] = this.GetTaskRanges();
        taskTimeRanges = taskAssignmentId
            ? taskTimeRanges.filter((task) => task.id !== taskAssignmentId)
            : taskTimeRanges;

        const dialogRef = this.dialog.open(TaskAssignmentDialogComponent, {
            data: {
                id: taskAssignmentId,
                sensorAssignmentId: this.sensorAssignmentData.id,
                sampleStartTime: this.sensorAssignmentData.startDate,
                sampleEndTime: this.sensorAssignmentData.endDate,
                taskTimeRanges: taskTimeRanges,
            },
            width: "550px",
            disableClose: true,
        });

        this.handleDialogClose(dialogRef);
    }

    private GetTaskRanges(): TaskTimeRange[] {
        return this.taskAssignmentDataSource
            .map((task) => {
                return task.taskAssignments.map((t) => ({
                    id: t.id,
                    startDate: t.startDate,
                    endDate: t.endDate,
                }));
            })
            .flat();
    }

    handleDialogClose(dialogRef: MatDialogRef<any, any>): void {
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.loadTaskAssignmentEmit.emit();
            }
        });
    }

    openMultipleTaskDialog(
        taskAssignmentExposureContribution: TaskAssignmentExposureContribution,
    ) {
        const taskTimeRanges: TaskTimeRange[] = this.GetTaskRanges();
        const dialogRef = this.dialog.open(MultipleTaskAssignmentDialog, {
            data: {
                taskAssignmentExposure: taskAssignmentExposureContribution,
                sensorAssignmentId: this.sensorAssignmentData.id,
                sampleStartTime: this.sensorAssignmentData.startDate,
                sampleEndTime: this.sensorAssignmentData.endDate,
                taskTimeRanges: taskTimeRanges,
                isReadonly: true,
            },
            width: "550px",
            disableClose: true,
        });

        this.handleDialogClose(dialogRef);
    }

    openTaskDeleteDialog(taskAssignment: TaskAssignmentExposureContribution) {
        if (taskAssignment?.taskAssignments?.length > 0) {
            const dialogRef = this.dialog.open(DeleteDialog, {
                data: {
                    id: taskAssignment.taskAssignments[0].id,
                    formDeletes: true,
                    service: this.taskAssignmentService,
                    title: "Task",
                },
                width: "440px",
            });

            this.handleDialogClose(dialogRef);
        }
    }

    public trackByIndex = trackByIndex;
}
